import { StripeAccountRedirect as StripeAccountRedirectComponent } from './views/StripeAccountRedirect';

export const StripeAccountRedirect = StripeAccountRedirectComponent; 